import { MainController } from "../controller/mainController";
import { IntroScene } from "../display/introScene";
import { Text } from "../display/text";

class Chapter3Intro extends IntroScene {



	constructor() {
		super("chapter3Intro");
        this.chapter = "chapter3";
		this.title = Text.get('chapter3-intro-title');
		this.subtitle = Text.get('chapter3-intro-subtitle');
      MainController.registerChapter(this);
    } 


    create ()
    {
        super.create();

        // j'enregistre la scène intro en bookmark
        MainController.bookmarkChapter(this);
        MainController.setCurrentScene( this );
        
		this.goToScene("chapter3Scene1", 5000);
    
    }


    beforeTransition()
    {
        //'on kill tout ce qui peut se déclencher pendant la transition'
        console.log('beforeTransition '+this.name);
    }

    beforeDestroy()
    {
        //'on peut tout killer'
        
    }

}
export {Chapter3Intro}